import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

function pageMeta(obj) {
	return {
		metaInfo: Object.assign({}, {title: '登录',keywords: '',description: ''}, obj)
	}
};

const routes = [{
		path: '/',
		name: 'login',
		component: () => import('@/views/login.vue'),
		meta: pageMeta({title: '登录'}),
	},
	{
		path: '/wxlogin/login',
		name: 'wxlogin/login',
		component: () => import('@/views/wxlogin/login.vue'),
		meta: pageMeta({title: '微信登录'}),
	},
	{
		path: '/wxlogin/bind',
		name: 'wxlogin/bind',
		component: () => import('@/views/wxlogin/bind.vue'),
		meta: pageMeta({title: '微信绑定'}),
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('@/views/index.vue'),
		meta: pageMeta({title: '集合页'}),
	},
	{
		path: '/index1',
		name: 'index',
		component: () => import('@/views/index1.vue'),
		meta: pageMeta({title: '集合页'}),
	},

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
